import { useState, useEffect } from 'react';
import { useTour } from '@reactour/tour';
import { useNavigate } from 'react-router-dom';
import { createOnboardingTour, SidebarTourConfig } from '../components/SidebarTour';
import { USER_IS_FIRST_LOGIN, USER_ONBOARDING_TOUR_COMPLETED } from '../axios/constants';

export const useOnboardingTour = () => {
  const [shouldStartTour, setShouldStartTour] = useState(false);
  const { setIsOpen, setSteps } = useTour();
  const navigate = useNavigate();

  const startOnboardingTour = () => {
    const tourSteps = createOnboardingTour(navigate);
    setSteps(tourSteps);
    setIsOpen(true);
    localStorage.setItem(USER_ONBOARDING_TOUR_COMPLETED, 'false');
  };

  const checkForNewUser = () => {
    const tourCompleted = localStorage.getItem(USER_ONBOARDING_TOUR_COMPLETED);
    const isFirstLogin = localStorage.getItem(USER_IS_FIRST_LOGIN);
    
    if (isFirstLogin === 'true' && tourCompleted !== 'true') {
      setShouldStartTour(true);
      localStorage.setItem(USER_IS_FIRST_LOGIN, 'false');
    }
  };

  const completeTour = () => {
    localStorage.setItem(USER_ONBOARDING_TOUR_COMPLETED, 'true');
    setShouldStartTour(false);
    setIsOpen(false);
    setSteps(SidebarTourConfig);
    console.log("Tour completed", SidebarTourConfig);
  };

  useEffect(() => {
    checkForNewUser();
  }, []);

  useEffect(() => {
    if (shouldStartTour) {
      setTimeout(() => {
        startOnboardingTour();
      }, 1000); // Delay to ensure page is fully loaded
    }
  }, [shouldStartTour]);

  return {
    startOnboardingTour,
    completeTour,
    shouldStartTour
  };
};